import { THEME } from '@lyon/utils/theme';
import { BlockOverrides } from 'baseui/block';

export const NORMAL: BlockOverrides = {
  Block: {
    style: {
      fontSize: '14px',
      lineHeight: 1.65,
      fontWeight: 400,
    },
  },
};

export const PURPLE: BlockOverrides = {
  Block: {
    style: {
      color: THEME.colors.primary400,
      fontWeight: 700,
      fontSize: '14px',
      alignItems: 'center',
      display: 'flex',
    },
  },
};
